import React from "react"

const Coverage = () => {

    return(
        <section className="py-5 text-center" style={{ background: 'linear-gradient(to right, #38C6C3,rgb(56, 198, 153))' }}>
            <div className="container">
                <h2 className="text-uppercasemb-4"style={{color:'#0f174f'}}>Check Coverage</h2>
                
                <form className="row justify-content-center">
                  <div className="col-md-6 mb-3">
                    <label className="form-label d-block text-center mb-2 fw-semibold">
                        Enter your address to see if FTTBSA is available in your area.
                    </label>
                    <input
                        type="text"
                        className="form-control form-control-lg text-center"
                        placeholder="Enter your business address"
                    />
                    <div className="mb-3 py-2">
                    <a className="btn btn-lg w-100 text-white" href="#Contact" style={{backgroundColor:'#0f174f'}}>
                      Check
                    </a>
                  </div>
                    </div>

                  
                </form>
            </div>
        </section>
    );
};

export default Coverage;